var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgPlayVideo(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M18.9 11.5c1.5-.8 1.5-2.1 0-2.9L2.8.3C1.3-.5 0 .2 0 1.8v16.4c0 1.5 1.3 2.3 2.8 1.5l16.1-8.2z",
    fill: "#fff"
  })));
}
export default SvgPlayVideo;